
export default {
  // Auth-related translations
  "sign_in": "로그인",
  "sign_up": "회원가입",
  "email_address": "이메일 주소",
  "password": "비밀번호",
  "new_password": "새 비밀번호",
  "confirm_password": "비밀번호 확인",
  "forgot_password": "비밀번호를 잊으셨나요?",
  "reset_password": "비밀번호 재설정",
  "verification_code": "인증 코드",
  "enter_verification_code": "이메일로 전송된 6자리 코드를 입력하세요",
  "passwords_dont_match": "비밀번호가 일치하지 않습니다",
  "password_too_short": "비밀번호는 최소 8자 이상이어야 합니다",
  "invalid_code": "유효하지 않거나 만료된 코드",
  "invalid_code_format": "인증 코드는 6자리 숫자여야 합니다",
  "password_reset_success": "비밀번호가 성공적으로 재설정되었습니다",
  "send_reset_link": "임시 비밀번호 보내기",
  "reset_link_sent": "재설정 링크가 이메일로 전송되었습니다",
  "temp_password_sent": "임시 비밀번호가 이메일로 전송되었습니다",
  "reset_link_error": "재설정 링크 전송에 실패했습니다. 나중에 다시 시도해주세요.",
  "email_delivery_not_configured": "이메일 전송이 구성되지 않았습니다. 관리자에게 문의하세요.",
  "for_testing_use": "개발 테스트의 경우 Supabase CLI 또는 대시보드를 사용하여 사용자를 관리할 수 있습니다",
  "processing": "처리 중...",
  "back": "뒤로",
  "verify_code": "인증 코드 입력",
  "email_not_received": "이메일을 받지 못하셨나요?",
  "leave_page_warning": "저장되지 않은 변경 사항이 있습니다. 이 페이지를 떠나시겠습니까? 비밀번호 재설정 진행 상황이 손실됩니다.",
  "reset_link_required": "비밀번호를 재설정하려면 유효한 재설정 링크가 필요합니다",
  // New rate limit messages
  "reset_rate_limit_exceeded": "이메일 전송 한도를 초과했습니다. 잠시 후 다시 시도해주세요.",
  "reset_rate_limit_message": "다른 임시 비밀번호를 요청하기 전에 {{seconds}}초 동안 기다려주세요.",
  "wait_before_retry": "다시 시도하기 전에 기다리세요",
  // Temporary password messages
  "password_reset_required": "계속하려면 비밀번호를 변경해야 합니다",
  "temp_password_instructions": "임시 비밀번호를 사용 중입니다. 새 비밀번호를 생성해주세요.",
  
  // Username dialog related translations
  "create_username": "사용자 이름 만들기",
  "username_required_description": "계속하려면 사용자 이름을 만들어주세요. 사용자 이름은 다른 사용자에게 표시됩니다.",
  "username": "사용자 이름",
  "username_placeholder": "사용자 이름 입력",
  "username_requirements": "사용자 이름은 문자, 숫자 및 밑줄만 포함할 수 있습니다.",
  "save_username": "사용자 이름 저장",
  "username_taken": "이 사용자 이름은 이미 사용 중입니다. 다른 이름을 시도해주세요.",
  "username_set_success": "사용자 이름이 성공적으로 설정되었습니다!",
  "username_set_error": "사용자 이름 설정에 실패했습니다. 다시 시도해주세요.",
  "auth_error": "인증 오류. 다시 로그인해주세요.",
  "sign_in_success": "로그인 성공!",
  "sign_in_failed": "로그인에 실패했습니다",
  "completing_sign_in": "로그인 완료 중...",
  "please_wait": "자격 증명을 확인하는 동안 기다려주세요.",
  "or_continue_with": "또는 다음으로 계속",
  "or_with_email": "또는 이메일로",
  "continue_with_google": "Google로 계속",
  "dont_have_account": "계정이 없으신가요?",
  "already_have_account": "이미 계정이 있으신가요?",
  "magic_link_sent": "매직 링크가 이메일로 전송되었습니다",
  "magic_link_error": "매직 링크 전송에 실패했습니다. 나중에 다시 시도해주세요.",
  "send_magic_link": "매직 링크 보내기"
};
